import { Directive, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appAudio]'
})
export class AudioDirective implements OnChanges {

  @Input() play = false;
  @Input() rewind = 0;
  @Output() audioFinish = new EventEmitter<void>();

  audio: any;

  constructor(el: ElementRef) {
    this.audio = el.nativeElement
    this.audio.addEventListener('ended', () => {
      this.audioFinish.emit();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.play && !changes.play.firstChange) {
      if (this.play == true) {
        // this.audio.play;
        this.audio.play();
      } else {
        this.audio.pause();
        console.log(this.audio.currentTime);
      }
    } else {
      if (!changes.rewind.firstChange) {
        console.log("rewind: " + changes.rewind.currentValue);
        if (this.audio.currentTime < 15) {
          this.audio.currentTime = 0;
        } else {
          this.audio.currentTime = this.audio.currentTime-15;
        }
      }
    }
  }

}
